
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.72 12.76c.35-.85.54-1.76.54-2.76 0-.72-.11-1.41-.3-2.05-.65.15-1.33.23-2.04.23A9.07 9.07 0 017.5 4.34a9.21 9.21 0 01-4.73 4.88c-.04.25-.04.52-.04.78a7.264 7.264 0 0010.24 6.63c.57 1.09.83 1.63.81 1.63-1.64.55-2.91.82-3.78.82-2.42 0-4.73-.95-6.43-2.66a9.03 9.03 0 01-2.24-3.69H0V8.18h1.09a9.09 9.09 0 0115.33-4.6 8.991 8.991 0 012.47 4.6H20v4.55h-.06L16.38 16l-5.3-.6v-1.67h4.83l.81-.97zM7.27 9.77c.3 0 .59.12.8.34a1.136 1.136 0 010 1.6c-.21.21-.5.33-.8.33-.63 0-1.14-.5-1.14-1.13 0-.63.51-1.14 1.14-1.14zm5.45 0c.63 0 1.13.51 1.13 1.14 0 .63-.5 1.13-1.13 1.13-.63 0-1.14-.5-1.14-1.13 0-.63.51-1.14 1.14-1.14z","fill":"#454444"}})])
          )
        }
      }
    